// extracted by mini-css-extract-plugin
export var band = "InlineAlert-module--band--ecc11";
export var card = "InlineAlert-module--card--14338";
export var cta = "InlineAlert-module--cta--fc6f5";
export var danger = "InlineAlert-module--danger--9be64";
export var icon = "InlineAlert-module--icon--7859b";
export var info = "InlineAlert-module--info--c127c";
export var lead = "InlineAlert-module--lead--e7b78";
export var message = "InlineAlert-module--message--89151";
export var success = "InlineAlert-module--success--9dd53";
export var tailed = "InlineAlert-module--tailed--2372b";
export var tick = "InlineAlert-module--tick--bc3d0";
export var warning = "InlineAlert-module--warning--04aa9";